import { STORES_API } from 'modules/stores/api/stores-api'
import { ProfileUpdateInterface } from 'modules/stores/store/content/profile/types/profile-interface'
import { StoreId, StoreInterface } from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useProfileActions = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.put, StoreInterface>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: () => {},
  })

  const updateProfile = (id: StoreId, data: ProfileUpdateInterface) =>
    fetcher(`${STORES_API}/${id}/profile`, data)

  return { updateProfile }
}
